import { h, Fragment } from 'preact';
import { formatMoney } from 'utils/storefront/format-resource';

const CartProductPrice = ({ line }) => {
  const getSalePrice = () => {
    if (
      line.properties?._compare_price &&
      parseFloat(line.properties._compare_price)
    ) {
      return line.properties._compare_price;
    }
    if (line.discounted_price !== line.price) return line.original_price / 100;
    return false;
  };


  const salePrice = getSalePrice();
  const regularPrice = (line.line_price / line.quantity) / 100;

  return (
    <>
      {/* Compare price */}
      {!!salePrice && (
        <s className="text-grey-2">
          {formatMoney({
            amount: salePrice,
            currencyCode: window.TMW?.localization?.currencyCode,
          })}
        </s>
      )}
      {/* Regular price */}
      <span className={`${salePrice ? 'text-red ml-2' : ''}`}>
        {formatMoney({
          amount: regularPrice,
          currencyCode: window.TMW?.localization?.currencyCode,
        })}
      </span>
    </>
  );
};
export default CartProductPrice;
